import React, { useEffect, useState } from "react";
import axios from "axios";
import UserManager from "../components/UserManager";
import ClientesPanel from "../components/ClientesPanel";
import GestionAccesos from "../components/GestionAccesos";
import ContenidoAdmin from "../components/ContenidoAdmin";
import AdminChatPanel from "../components/AdminChatPanel";
import SeguimientoPanel from "../components/SeguimientoPanel";
import PersonalRoutineEditor from "../components/PersonalRoutineEditor";
import NutritionAdmin from "../components/NutritionAdmin";
import SideNav from "../components/SideNav";
import { getSession, clearSession } from "../utils/session";
import { API_URL } from "../services/api";
import { FiClipboard, FiCoffee, FiBookOpen, FiLogOut, FiMenu, FiMessageCircle, FiUserCheck, FiUsers, FiZap } from "react-icons/fi";
import "./AdminPanel.css";

const MENU = [
  { key: "messages", label: "Mensajes", Icono: FiMessageCircle },
  { key: "users", label: "Clientes", Icono: FiUsers },
  { key: "cuentas", label: "Cuentas", Icono: FiUserCheck },
  { key: "routines", label: "Rutinas", Icono: FiClipboard },
  { key: "nutricion", label: "Nutrición", Icono: FiCoffee },
  { key: "contenido", label: "Contenido", Icono: FiBookOpen },
  { key: "seguimiento", label: "Seguimiento", Icono: FiZap },
];

function AdminPanel() {
  const [activeTab, setActiveTab] = useState("users"); // abre en Clientes
  const [selectedUser, setSelectedUser] = useState(null);
  const [menuAbierto, setMenuAbierto] = useState(false);
  const [rutinas, setRutinas] = useState(null); // userId -> fecha de la rutina asignada

  // Quién tiene rutina, cada vez que se vuelve a la lista de Rutinas
  useEffect(() => {
    if (activeTab !== "routines" || selectedUser) return;
    getSession()
      .then(({ token }) => axios.get(`${API_URL}/personal-routines`, { headers: { Authorization: `Bearer ${token}` } }))
      .then((res) => setRutinas(new Map(res.data.map((r) => [r.userId, r.updatedAt]))))
      .catch(() => setRutinas(null));
  }, [activeTab, selectedUser]);

  const renderContent = () => {
    switch (activeTab) {
      case "messages":
        return <AdminChatPanel />;
      case "users":
        return (
          <>
            {/* Aprobar y suspender nada más entrar */}
            <GestionAccesos />
            <ClientesPanel />
          </>
        );
      case "cuentas":
        // Aprobar, suspender o dar de alta cuentas de clientes
        return <UserManager />;
      case "seguimiento":
        return <SeguimientoPanel />;
      case "contenido":
        return <ContenidoAdmin />;
      case "nutricion":
        return <NutritionAdmin />;
      case "routines":
        // Mostrar selector de usuario si no hay uno seleccionado
        if (!selectedUser)
          return (
            <div>
              <p className="app-sub admin-sub">Elige a quién le preparas la rutina.</p>
              <UserManager onSelectUser={setSelectedUser} rutinas={rutinas} showOnlyList />
            </div>
          );
        return <PersonalRoutineEditor usuario={selectedUser} onVolver={() => setSelectedUser(null)} />;
      default:
        return null;
    }
  };

  // Recarga completa para soltar el socket del chat y el estado del panel
  const cerrarSesion = async () => {
    await clearSession();
    window.location.replace("/");
  };

  const titulo = MENU.find((m) => m.key === activeTab)?.label;

  return (
    <div className="admin-container">
      <header className="dashboard-header">
        <div className="dashboard-header-inner">
          <button
            type="button"
            className="menu-btn"
            onClick={() => setMenuAbierto(true)}
            aria-label="Abrir menú"
          >
            <FiMenu />
          </button>
          <span className="brand">
            <span className="brand-mark">
              <img src="/titan-mark.png" alt="" />
            </span>
            <span className="brand-name">Titan Training</span>
          </span>
          <span className="sidenav-etiqueta">Entrenador</span>
        </div>
      </header>

      <main className="admin-content">
        <h1 className="dash-titulo">{titulo}</h1>
        <div className="admin-cuerpo">{renderContent()}</div>
      </main>

      <SideNav
        items={MENU}
        selected={activeTab}
        onSelect={setActiveTab}
        abierto={menuAbierto}
        onCerrar={() => setMenuAbierto(false)}
        etiqueta="Entrenador"
        pie={
          <button type="button" className="sidenav-usuario" onClick={cerrarSesion}>
            <FiLogOut aria-hidden="true" />
            <span>Cerrar sesión</span>
          </button>
        }
      />
    </div>
  );
}

export default AdminPanel;
